import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { toast, ToastContainer } from "react-toastify";
import { common_axios } from "../../../App";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { InputAdornment, Tooltip, TextField, IconButton } from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { dateFormatter } from "../../../helper/helper";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import InfoIcon from "@mui/icons-material/Info";
import * as yup from "yup";
import { Form, Formik, useFormik, Field, FieldArray } from "formik";
import Swal from "sweetalert2";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import * as React from "react";
import Pagination from "@mui/material/Pagination";
import {
  Stack,
} from "@mui/material";
const AddNewList = ({ changeState }) => {
  const [data, setData] = useState([]);
  const [hideSkeleton, setHideSkeleton] = useState();
  const [ContactArray, SetContactArray] = useState([]);
  const [Namedata, setNamedata] = useState("");
  const [searchPhoneBookState, setSearchPhoneBookState] = useState("");
  const [error, seterror] = useState(false);

  const customId1 = "custom-id-yess";
  // useEffect(() => {
  //   if (Namedata != 1) {
  //     for (let i = 0; i < ContactArray.length; i++) {
  //       if (ContactArray[i]?.id == Namedata) {
  //         setData(ContactArray[i]?.userContactList);
  //       }
  //     }
  //   } else {
  //     ListGet();
  //   }
  // }, [Namedata, ContactArray]);
  const [arrayvalue, setArrayValue] = useState("default");
  const [paginationPage, setPaginationPage] = React.useState(1);

  const [TableStatus, setTableStatus] = useState({
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  const [data1, setData1] = useState([]);
  function handleChange1(event) {
    setNamedata(event.target.value);
  }
  useEffect(() => {
    for (let i = 0; i < ContactArray.length; i++) {
      if (ContactArray[i] == Namedata) {
        setData(ContactArray[i]?.userContactList);
      }
    }
  }, [ContactArray, Namedata]);
  const history = useHistory();

  const initialValues = {
    msisdn: "",
    contactName: "",
    // emailId: "",
    // description:""
  };
  const validationSchema = yup.object({
    msisdn: yup
      .string()
      .min(8, "Minimum length of a mobile number is 8 digits")
      .max(8, "Maximum length of mobile number is 8 digits")
      // .required("Required"),
      // .required("Required"),
      .nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // ContactPost(values);
      FilterBtn(values);
    },
  });
  async function ListGet() {
    // console.log("entering to the Listget", Namedata);
    try {
      setOpen(true);
      // if (Namedata == "0") {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/fetchAllContactsByUser`,
        {
          pageNo: TableStatus?.pageNo,
          pageSize: TableStatus?.pageSize,
          phoneBookId: "0",
        }
      );
      if (result.data.statusdescription.statusCode == 200) {
        setOpen(false);
        // await setTotalPage(result.data.page.totalPages);
        // await settotalPageCount(result.data.page.pageable.pageNumber);
        await setData(result.data.page.content);
        await setData1(result.data.page);
      } else {
        setOpen(false);
      }
      // }
      //  else {
      //   const result = await common_axios.post(
      //     `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/ `,
      //     {
      //       pageNo: TableStatus?.pageNo,
      //       pageSize: TableStatus?.pageSize,
      //       phoneBookId: Namedata,
      //     }
      //   );
      //   if (result.data.statusdescription.statusCode == 200) {
      //     setOpen(false);
      //     // await setTotalPage(result.data.page.totalPages);
      //     // await settotalPageCount(result.data.page.pageable.pageNumber);
      //     await setData(result.data.page.content);
      //     await setData1(result.data.page);
      //   } else {
      //     setOpen(false);
      //     toast.error(result.data.statusdescription.statusDescription, {
      //       toastId: customId1,
      //     });
      //   }
      // }
    } catch (error) {
      // setHideSkeleton(false);

      setOpen(false);
      // toast.error("Please Check Your Network",{
      //   toastId: customId1,
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  const y = useSelector((state) => state.contactReducer?.contactState);
  const b = useSelector((state) => state.pageReducer.BulkUploadList?.payload);

  useEffect(() => {
    // if(data.length>0)
    ListGet();
  }, [y, b, changeState, TableStatus.pageSize, TableStatus.pageNo]);
  async function ContactGet(values) {
    try {
      setHideSkeleton(true);
      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/bulk-group/get/phone-book/list`
      );
      if (res.data.statusdescription.statusCode == 200) {
        setHideSkeleton(false);
        SetContactArray(res?.data?.listOfPlaysmsPhonebook);
      } else {
        setHideSkeleton(false);
        SetContactArray([]);
        // toast.error(res.data.statusdescription.statusDescription ,{
        //   toastId: customId1,
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setHideSkeleton(false);
      // toast.error("Please Check Your Network",{
      //   toastId: customId1,
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  const handleChange2 = (e) => {
    setSearchPhoneBookState(e.target.value);
  };

  const x = useSelector((state) => state.contactReducer?.contactState);
  // console.log("abc",x)
  useEffect(() => {
    ContactGet();
  }, [x]);
  // .................................KEYWORD DELETE API...................................//
  const [open, setOpen] = useState();
  const rejectUserApi = async (selectedUserDetail) => {
    try {
      setOpen(true);
      const deleteResponse = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/contacts/delete-contact?contactId=${selectedUserDetail.id}`
      );
      // console.log("deleteResponse--------", deleteResponse);
      if (deleteResponse.data.statusdescription.statusCode == 200) {
        setOpen(false);
        // FilterGet();
        ContactGet();
        ListGet();
        // toast.success("Deleted successfully!!", {
        //   theme: "colored",
        // });

        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: "Deleted successfully!!",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        // toast.error(deleteResponse.data.statusdescription.statusDescription,{
        //   toastId: customId1,
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: deleteResponse.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // toast.error("Please Check Your Network",{
      //   toastId: customId1,
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      setOpen(false);
    }
  };

  //.............................Keyword Update API.................................//
  const approveUserApi = async (selectedUserDetailApprove) => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/contacts/update-contact`,
        {
          contactId: selectedUserDetailApprove.id,
          contactName: selectedUserDetailApprove.contactName,
          mobileNumber: selectedUserDetailApprove.mobileNumber,
          emailId: selectedUserDetailApprove.email,
          bulklistName: "default",
        }
      );
      if (res.data.statusDescription.statusCode == 200) {
        ListGet();
        ContactGet();
        setOpen(false);

        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: "Updated successfully!!",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else if (res.data.statusDescription.statuscode == 202) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "already exists !!",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setOpen(false);
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // .....................................FilterButton.................................//
  async function FilterBtn(values) {
    try {
      setOpen(true);
      if (Namedata == 1) {
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/search/contact`,
          {
            msisdn: "222" + values.msisdn,
            contactName: null,
            pagination: {
              pageNo: TableStatus?.pageNo,
              pageSize: TableStatus?.pageSize,
            },
          }
        );
        if (res.data.statusdescription.statusCode == 200) {
          setData(res?.data?.page?.content);
          await setData1(res.data.page);

          setOpen(false);
        } else {
          setOpen(false);
          setData([]);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (Namedata == 2) {
        setOpen(true);

        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/search/contact`,
          {
            msisdn: null,
            contactName: values.contactName,
            pagination: {
              pageNo: TableStatus?.pageNo,
              pageSize: TableStatus?.pageSize,
            },
          }
        );
        if (res.data.statusdescription.statusCode == 200) {
          setData(res?.data?.page?.content);
          await setData1(res.data.page);
          setOpen(false);
        } else {
          setOpen(false);
          setData([]);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (Namedata == 0) {
        setOpen(true);

        const res = await common_axios.get(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/bulk-group/get/phone-book/list`
        );

        if (res.data.statusdescription.statusCode == 200) {
          setOpen(false);
          let temp_arr = [];
          for (let i = 0; i < res?.data?.listOfPlaysmsPhonebook?.length; i++) {
            if (
            
              searchPhoneBookState == res?.data?.listOfPlaysmsPhonebook[i]?.id
            ) {
              
              let x = res?.data?.listOfPlaysmsPhonebook[i]?.userContactList;
              for (let j = 0; j < x.length; j++) {
                temp_arr.push(x[j]);
              }
            }
          }
          // console.log("hnn",temp_arr)
          setData(temp_arr);
        } else {
          setOpen(false);
          setData([]);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);
  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };
  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };
  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        Cell: (cell) => (
          <>
            {cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}
          </>
        ),
      },

      {
        Header: "Contact Name",
        accessor: "contactName", // accessor is the "key" in the data
      },
      {
        Header: "Mobile Number",
        accessor: "mobileNumber",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Phonebook Name",
        accessor: "phoneBookName",
      },
      {
        Header: "Created On",
        accessor: "createdOn",
        // Cell: (cell) => {
        //   return <>{dateFormatter(cell.row.original.createdOn)}</>;
        // },
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: (cell) => (
          <div className="dropdown">
            <button
              className="btn color_1 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="material-icons opacity-10 size">person</i>
              {/* <DeleteIcon /> */}
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li
                onClick={() => {
                  // console.log(cell);
                }}
              >
                <a
                  className="dropdown-item"
                  onClick={() => {
                    rejectUserModal(cell);
                  }}
                >
                  <DeleteIcon className="color_red_UP me-2" />
                  Delete
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => {
                    approveUserModal(cell);
                  }}
                >
                  <EditIcon className="color_Green_UP me-2" />
                  Edit Details
                </a>
              </li>
            </ul>
          </div>
        ),
        disableFilters: true,
      },
    ],
    [TableStatus]
  );
  // console.log(Status, "lalalaallalas");
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    previousPage,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );
  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  return (
    <>
      <main className="main-content position-relative border-radius-lg ">
        <div>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>
        <div className="card-body">
          <div className="card shadow-none border bg_blue mt-4">
            <span className="badge rounded-pill bg-primary mt-n3 ms-5">
              {/* Add Number */}
              View Contact
            </span>
            <div className="card-body text-lg-start text-center">
              <section class="cmp">
                <div class="container-fluid">
                  <form
                    onSubmit={formik.handleSubmit}
                    role="form"
                    className="text-start"
                  >
                    {/* <div className="d-flex justify-content-between"> */}

                    <div class="row justify-content-between mb-3">
                      <div class="col-md-3">
                        {TableStatus.hideShow && (
                          <>
                            {hideSkeleton == true ? (
                              <>
                                <Box sx={{ width: 230 }}>
                                  <Skeleton />
                                  <Skeleton animation="wave" />
                                  {/* <Skeleton animation={false} /> */}
                                </Box>
                              </>
                            ) : (
                              <>
                                {/* <FormControl required fullWidth size="small">
                                <InputLabel id="demo-simple-select-autowidth-label">
                                  PhoneBook List
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-autowidth-label"
                                  id="demo-simple-select-autowidth"
                                  value={Namedata}
                                  onChange={handleChange1}
                                  autowidth
                                  label=" PhoneBook List"
                                  // required
                                >
                                  <MenuItem selected value={0}>
                                    All
                                  </MenuItem>
                                  {ContactArray.map((arg) => {
                                    return (
                                      <MenuItem value={arg.id}>
                                        {" "}
                                        {arg.phonebookName}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl> */}

                                <FormControl required fullWidth size="small">
                                  <InputLabel id="demo-simple-select-autowidth-label">
                                    Search Category
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={Namedata}
                                    onChange={handleChange1}
                                    autowidth
                                    label=" Search Category"
                                    // required
                                  >
                                    {/* <MenuItem selected value={0}>
                                    All
                                  </MenuItem> */}

                                    <MenuItem value={0}>
                                      PhoneBookList{" "}
                                    </MenuItem>
                                    <MenuItem value={1}>
                                      Mobile Number{" "}
                                    </MenuItem>
                                    <MenuItem value={2}>Contact Name </MenuItem>
                                  </Select>
                                </FormControl>
                              </>
                            )}
                          </>
                        )}
                      </div>
                      {Namedata === 0 && (
                        <>
                          <div class="col-md-3">
                            <FormControl required fullWidth size="small">
                              <InputLabel id="demo-simple-select-autowidth-label">
                                Phonebook name
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                value={searchPhoneBookState}
                                onChange={handleChange2}
                                autowidth
                                label=" Phonebook name"
                                // required
                              >
                                {ContactArray?.map((arg) => {
                                  return (
                                    <MenuItem value={arg?.id}>
                                      {arg?.phonebookName}{" "}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </div>
                        </>
                      )}
                      {Namedata == 1 && (
                        <>
                          <div className="col-md-3" id="inp_merge">
                            <div className="d-flex">
                              <input
                                className="inpt_width"
                                disabled
                                value="+222"
                              />
                              <TextField
                                className=" w-100"
                                style={{
                                  borderRadius: "4px",
                                }}
                                type="string"
                                label="Mobile Number"
                                name="msisdn"
                                variant="outlined"
                                size="small"
                                required
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Tooltip
                                        title="Mobile Number"
                                        placement="top"
                                        arrow
                                        sx={{ color: "#85CBF2" }}
                                      >
                                        <InfoIcon />
                                      </Tooltip>
                                    </InputAdornment>
                                  ),
                                }}
                                onChange={formik.handleChange}
                                value={formik.values.msisdn}
                                error={
                                  formik.touched.msisdn &&
                                  Boolean(formik.errors.msisdn)
                                }
                                helperText={
                                  formik.touched.msisdn && formik.errors.msisdn
                                }
                                onInput={(e) => {
                                  // e.target.value = Math.max(0, parseInt(e.target.value))
                                  //   .toString()
                                  //   .slice(0, 8);
                                  e.target.value = e.target.value.slice(0, 8);
                                }}
                                onKeyPress={(event) => {
                                  const keyCode = event.keyCode || event.which;

                                  if (
                                    (keyCode >= 48 && keyCode <= 57) ||
                                    keyCode == 13
                                  ) {
                                    seterror(false);
                                  } else {
                                    event.preventDefault();
                                    seterror(true);
                                  }
                                }}
                              />
                            </div>

                            <div className="row">
                              {error == true ? (
                                <>
                                  <p style={{ color: "red" }}>
                                    Only Numbers Are Allowed!!
                                  </p>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {Namedata == 2 && (
                        <>
                          <div className="col-md-3">
                            <TextField
                              className=" w-100"
                              style={{
                                borderRadius: "4px",
                              }}
                              type="text"
                              label="Contact Name"
                              name="contactName"
                              variant="outlined"
                              size="small"
                              required
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Tooltip
                                      title="Contact Name"
                                      placement="top"
                                      arrow
                                      sx={{ color: "#85CBF2" }}
                                    >
                                      <InfoIcon />
                                    </Tooltip>
                                  </InputAdornment>
                                ),
                              }}
                              onChange={formik.handleChange}
                              value={formik.values.contactName}
                              error={
                                formik.touched.contactName &&
                                Boolean(formik.errors.contactName)
                              }
                              helperText={
                                formik.touched.contactName &&
                                formik.errors.contactName
                              }
                            />
                          </div>
                        </>
                      )}

                      {TableStatus.hideShow && (
                        <>
                          <div className="col-md-3 mt-1">
                            {/* <button type="submit">filter</button> */}
                            <button
                              type="submit"
                              className={"btn btn-primary filter my-auto"}
                              style={{ fontSize: "13px", boxShadow: "none" }}
                            >
                              <FilterAltIcon
                                style={{
                                  fontSize: "16px",
                                  margin: "auto",
                                }}
                              />
                            </button>
                          </div>
                        </>
                      )}

                      <div class="col-md-3 ms-auto">
                        <div className="text-end" style={{ flexGrow: "1" }}>
                          <IconButton
                            variant="text"
                            size="small"
                            sx={{
                              color: "#7B809A",
                            }}
                            onClick={(event) => {
                              setTableStatus({
                                ...TableStatus,
                                hideShow: !TableStatus.hideShow,
                              });
                              setNamedata("");
                            }}
                          >
                            {TableStatus.hideShow ? (
                              <CancelIcon />
                            ) : (
                              <SearchIcon />
                            )}
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    {/* </div> */}

                    {/* <div className="d-flex justify-content-end my-3">
                    <button
                      type="submit"
                      class="btn btn-primary text-capitalize d-block w-auto m-0  "
                    
                    >
                      Get All
                      <GetAppIcon
                        style={{ fontSize: "18px", marginLeft: "4px" }}
                      />
                    </button>

                    <button
                      type="submit"
                      class="btn btn-primary text-capitalize d-block  m-0 ms-2"
                    >
                      Search
                      <SearchRoundedIcon style={{ fontSize: "18px" }} />
                    </button>
                    <button
                      type="button"
                      className="btn bg-gradient-secondary ms-2 w_btn btn_w8 m-0"
                      // onClick={Reset}
                    >
                      Reset
                      <SettingsBackupRestoreRoundedIcon
                        style={{ fontSize: "17px" }}
                      />
                    </button>
                  </div> */}

                    {data.length > 0 ? (
                      <>
                        <div className="border_btm_6"></div>
                        <>
                          <div class="row">
                            <div className="d-flex justify-content-between mt-3">
                              <select
                                value={TableStatus.pageSize}
                                className="dropdown"
                                onChange={(e) => {
                                  setPageSize(Number(e.target.value));
                                  setTableStatus({
                                    ...TableStatus,
                                    pageSize: e.target.value,
                                    pageNo: 0,
                                  });
                                }}
                              >
                                {[10, 25, 50].map((value, i) => {
                                  return (
                                    <option
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                      value={value}
                                      key={value}
                                    >
                                      Show {value}
                                    </option>
                                  );
                                })}
                              </select>
                              {/* <div className="d-flex align-items-center">
                              <TextField
                                className="ms-4 w-100"
                                style={{
                                  borderRadius: "4px",
                                }}
                                type="text"
                                label="Search"
                                name="Search"
                                variant="outlined"
                                size="small"
                                value={globalSearchValue || ""}
                                onChange={(e) => {
                                  onChange(e.target.value);
                                  setGlobalSearchValue(e.target.value);
                                }}
                              />
                            </div> */}
                            </div>

                            <section class="col-md-12 right_panel px-0">
                              <div class="container-fluid_ px-0">
                                <section class="" id="manage_list">
                                  <div>
                                    {/* {selectedUserDetail != undefined && ( */}
                                    <div>
                                      <button
                                        ref={modelButtonReject}
                                        type="button"
                                        className="btn btn-primary d-none"
                                        data-bs-toggle="modal"
                                        data-bs-target="#staticBackdrop"
                                      >
                                        Launch static backdrop modal
                                      </button>

                                      <div
                                        className="modal fade"
                                        id="staticBackdrop"
                                        data-bs-backdrop="static"
                                        data-bs-keyboard="false"
                                        tabindex="-1"
                                        aria-labelledby="staticBackdropLabel"
                                        aria-hidden="true"
                                      >
                                        <div className="modal-dialog">
                                          <div className="modal-content">
                                            <div className="modal-header">
                                              <h5
                                                className="modal-title"
                                                id="staticBackdropLabel"
                                              >
                                                Are you sure you want to delete?
                                              </h5>
                                              <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                              ></button>
                                            </div>
                                            <div className="modal-body">
                                              <div className="row">
                                                <div className="col-md-6">
                                                  <label
                                                    for="exampleInputEmail1"
                                                    className="form-label"
                                                  >
                                                    ID:
                                                  </label>
                                                  <input
                                                    disabled
                                                    className="form-control"
                                                    placeholder=" Id "
                                                    type="text"
                                                    minLength="3"
                                                    value={
                                                      selectedUserDetail?.id
                                                    }
                                                  />
                                                </div>
                                                <div className="col-md-6 mt_2">
                                                  <label
                                                    for="exampleInputEmail1"
                                                    className="form-label"
                                                  >
                                                    Contact Name:
                                                  </label>
                                                  <input
                                                    disabled
                                                    className="form-control"
                                                    placeholder=" Contact Name "
                                                    type="text"
                                                    minLength="3"
                                                    value={
                                                      selectedUserDetail?.contactName
                                                    }
                                                  />
                                                </div>
                                              </div>
                                              <div className="row mt-2">
                                                <div className="col-md-6">
                                                  <label
                                                    for="exampleInputEmail1"
                                                    className="form-label"
                                                  >
                                                    Mobile Number:
                                                  </label>
                                                  <input
                                                    disabled
                                                    className="form-control"
                                                    placeholder=" Mobile Number "
                                                    type="text"
                                                    minLength="3"
                                                    value={
                                                      selectedUserDetail?.mobileNumber
                                                    }
                                                  />
                                                </div>
                                                <div className="col-md-6">
                                                  <label
                                                    for="exampleInputEmail1"
                                                    className="form-label"
                                                  >
                                                    Email:
                                                  </label>
                                                  <input
                                                    disabled
                                                    className="form-control"
                                                    placeholder="  Email "
                                                    type="text"
                                                    minLength="3"
                                                    value={
                                                      selectedUserDetail?.email
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="modal-footer justify-content-between">
                                              <button
                                                type="button"
                                                className="btn btn-secondary"
                                                data-bs-dismiss="modal"
                                              >
                                                Cancel
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-danger"
                                                data-bs-dismiss="modal"
                                                onClick={() => {
                                                  rejectUserApi(
                                                    selectedUserDetail
                                                  );
                                                }}
                                              >
                                                Delete
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* )} */}
                                    {selectedUserDetailApprove != undefined && (
                                      <div>
                                        <button
                                          ref={modelButtonApprove}
                                          type="button"
                                          className="btn btn-primary d-none"
                                          data-bs-toggle="modal"
                                          data-bs-target="#staticBackdrop1"
                                        >
                                          Launch static backdrop modal
                                        </button>

                                        <div
                                          className="modal fade"
                                          id="staticBackdrop1"
                                          data-bs-backdrop="static"
                                          data-bs-keyboard="false"
                                          tabindex="-1"
                                          aria-labelledby="staticBackdrop1Label"
                                          aria-hidden="true"
                                        >
                                          <div className="modal-dialog ">
                                            <div className="modal-content">
                                              <div className="modal-header">
                                                <h5
                                                  className="modal-title"
                                                  id="staticBackdrop1Label"
                                                >
                                                  Update Details
                                                </h5>
                                                <button
                                                  type="button"
                                                  className="btn-close"
                                                  data-bs-dismiss="modal"
                                                  aria-label="Close"
                                                ></button>
                                              </div>

                                              <div className="modal-body">
                                                <div className="row">
                                                  <div className="col-md-6">
                                                    <label
                                                      for="exampleInputEmail1"
                                                      className="form-label"
                                                    >
                                                      ID:
                                                    </label>
                                                    <input
                                                      disabled
                                                      className="form-control"
                                                      placeholder=" Id "
                                                      type="text"
                                                      minLength="3"
                                                      value={
                                                        selectedUserDetailApprove?.id
                                                      }
                                                      onChange={(e) => {
                                                        setSelectedUserDetailApprove(
                                                          {
                                                            ...selectedUserDetailApprove,
                                                            id: e.target.value,
                                                          }
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="col-md-6 mt_2">
                                                    <label
                                                      for="exampleInputEmail1"
                                                      className="form-label"
                                                    >
                                                      Mobile Number
                                                    </label>
                                                    <input
                                                      // disabled
                                                      className="form-control"
                                                      placeholder="  Mobile Number "
                                                      type="number"
                                                      maxLength="10"
                                                      value={
                                                        selectedUserDetailApprove?.mobileNumber
                                                      }
                                                      onChange={(e) => {
                                                        setSelectedUserDetailApprove(
                                                          {
                                                            ...selectedUserDetailApprove,
                                                            mobileNumber:
                                                              e.target.value,
                                                          }
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  className="row mt-2"
                                                  id="row_focus"
                                                >
                                                  <div className="col-md-6">
                                                    <label
                                                      for="exampleInputEmail1"
                                                      className="form-label"
                                                    >
                                                      Email:
                                                    </label>
                                                    <input
                                                      // disabled
                                                      className="form-control"
                                                      placeholder=" Email "
                                                      type="text"
                                                      minLength="3"
                                                      value={
                                                        selectedUserDetailApprove?.email
                                                      }
                                                      onChange={(e) => {
                                                        setSelectedUserDetailApprove(
                                                          {
                                                            ...selectedUserDetailApprove,
                                                            email:
                                                              e.target.value,
                                                          }
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="col-md-6">
                                                    <label
                                                      for="exampleInputEmail1"
                                                      className="form-label "
                                                    >
                                                      Contact Name:
                                                    </label>
                                                    <input
                                                      // disabled
                                                      className="form-control"
                                                      placeholder="  Contact Name "
                                                      type="text"
                                                      minLength="3"
                                                      value={
                                                        selectedUserDetailApprove?.contactName
                                                      }
                                                      onChange={(e) => {
                                                        setSelectedUserDetailApprove(
                                                          {
                                                            ...selectedUserDetailApprove,
                                                            contactName:
                                                              e.target.value,
                                                          }
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="modal-footer justify-content-between">
                                                <button
                                                  type="button"
                                                  className="btn btn-secondary shadow"
                                                  data-bs-dismiss="modal"
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                disabled= {
                                                    selectedUserDetailApprove?.mobileNumber ===
                                                      "" ||
                                                    selectedUserDetailApprove?.email ===
                                                      "" ||
                                                    selectedUserDetailApprove?.contactName ===
                                                      ""
                                                  }
                                                  type="button"
                                                  className="btn btn-primary editcolor shadow okbtn"
                                                  data-bs-dismiss="modal"
                                                  onClick={() => {
                                                    approveUserApi(
                                                      selectedUserDetailApprove
                                                    );
                                                  }}
                                                >
                                                  Update
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    <div className="container-fluid">
                                      <div class="card-body mt-2 px-0 table_overFlow">
                                        <div>
                                          {selectedFlatRows.length > 0 && (
                                            <button onClick={deletUser}>
                                              Delete Users
                                            </button>
                                          )}
                                        </div>

                                        <table
                                          {...getTableProps()}
                                          id="example"
                                          className="table table-striped table-bordered dataTable table-sm"
                                          style={{ width: "100%" }}
                                        >
                                          <thead>
                                            {headerGroups.map((headerGroup) => (
                                              <tr
                                                {...headerGroup.getHeaderGroupProps()}
                                              >
                                                {headerGroup.headers.map(
                                                  (column) => (
                                                    <th
                                                      {...column.getHeaderProps(
                                                        column.getSortByToggleProps()
                                                      )}
                                                      className="text-center width_2"
                                                    >
                                                      {column.render("Header")}
                                                      <span>
                                                        {column.isSorted
                                                          ? column.isSortedDesc
                                                            ? "↑"
                                                            : "↓"
                                                          : ""}
                                                      </span>
                                                    </th>
                                                  )
                                                )}
                                              </tr>
                                            ))}
                                          </thead>
                                          <tbody
                                            id="dropdown-item"
                                            {...getTableBodyProps()}
                                          >
                                            {page.map((row) => {
                                              prepareRow(row);
                                              return (
                                                <tr {...row.getRowProps()}>
                                                  {row.cells.map((cell) => {
                                                    return (
                                                      <td
                                                        {...cell.getCellProps()}
                                                        // className="text-center"
                                                        //                                       className={
                                                        //                           (cell.column.Header == "Id" ||
                                                        //                             cell.column.Header ==
                                                        //                               "Mobile Number" ||
                                                        // cell.column.Header == "Created On") &&
                                                        //                           "text-end"
                                                        //                         }

                                                        className={
                                                          cell.column.Header ==
                                                            "Mobile Number" ||
                                                          cell.column.Header ==
                                                            "Id"
                                                            ? "text-end"
                                                            : cell.column
                                                                .Header ==
                                                              "Action"
                                                            ? "text-center"
                                                            : "text-start"
                                                        }
                                                      >
                                                        {cell.render("Cell")}
                                                      </td>
                                                    );
                                                  })}
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                        <div className="d-flex justify-content-between">
                                          <div>
                                            <span>
                                              Page:
                                              <strong>
                                                {data1?.pageable?.pageNumber +
                                                  1}{" "}
                                                of {data1?.totalPages}
                                              </strong>
                                            </span>
                                          </div>



                                          <div className="prev_next d-flex align-items-center">
                <button
                      className=" css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      //  disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                       
                        setTableStatus({
                          ...TableStatus,
                          pageNo:0,
                        });
                        setPaginationPage(1)
                      }}
                    >
                      First
                    </button>

                <Stack spacing={2}>
              <Pagination
                onChange={(event, value) => {
                  console.log("va--", value);
                  setTableStatus({
                    ...TableStatus,
                    pageNo: Number(value) - 1,
                  });
                  setPaginationPage(value);
                }}
                page={paginationPage}
                count={data1 ? data1?.totalPages : ""}
               
                variant="outlined"
                shape="rounded"
                
            color="primary"
              />
            </Stack>
            <button
                      className=" css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      // disabled={
                      //   data1?.totalPages == data1?.pageable?.pageNumber + 1
                      //  }
                      onClick={() => {
                        // alert("gg")
                        setTableStatus({
                          ...TableStatus,
                          pageNo:data1?.totalPages -1 ,
                        });
                        setPaginationPage(data1?.totalPages)

                      }}
                    >
                      Last
                    </button>
                
              </div>


                                          {/* <div className="btn_n800">
                                            <button
                                              className="btn btn_primary "
                                              type="button"
                                              style={{ background: "#2C97D4" }}
                                              disabled={
                                                data1?.pageable?.pageNumber == 0
                                              }
                                              onClick={() => {
                                                setTableStatus({
                                                  ...TableStatus,
                                                  pageNo:
                                                    TableStatus.pageNo - 1,
                                                });
                                              }}
                                            >
                                              Prev
                                            </button>

                                            <button
                                              className="btn btn_primary ms-2"
                                              type="button"
                                              style={{ background: "#2C97D4" }}
                                              disabled={
                                                data1?.totalPages ==
                                                data1?.pageable?.pageNumber + 1
                                              }
                                              onClick={() => {
                                                setTableStatus({
                                                  ...TableStatus,
                                                  pageNo:
                                                    TableStatus.pageNo + 1,
                                                });
                                              }}
                                            >
                                              Next
                                            </button>
                               
                                          </div> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </section>
                                <section class="modal_1"></section>
                              </div>
                            </section>
                          </div>
                        </>
                      </>
                    ) : (
                      <>
                        <div className="text-center mt-4">
                          {data?.length == 0 && open ? null : (
                            <h5 className="text-center mt-4">No Record Found..!!</h5>
                          )}
                        </div>
                      </>
                    )}
                  </form>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default AddNewList;
